import { Dialog, DialogProps } from 'primereact/dialog';

export const StyledDialog = ({ children, ...props }: DialogProps) => {
  return (
    <Dialog className="w-11 lg:w-7" {...props}>
      {children}
    </Dialog>
  );
};
